/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react'
import { Control, FieldError, UseFormSetValue, useWatch } from 'react-hook-form'

import { Box, FormHelperText, OutlinedInput } from '@mui/material'

import { phone as maskPhone } from '../../utils/mask'

type Props = {
  control: Control
  id: string
  label: string
  error: FieldError
  setValue: UseFormSetValue<any>
}

function PhoneField({ control, id, label, error, setValue, ...props }: Props, ref: React.Ref<HTMLInputElement>) {
  const phone = useWatch({ control, name: id })

  useEffect(() => {
    if (!phone) {
      return
    }
    const value = maskPhone(phone)
    setValue(id, value)
  }, [id, phone, setValue])

  return (
    <>
      <FormHelperText>{label}</FormHelperText>
      <OutlinedInput
        fullWidth
        ref={ref}
        id={id}
        type="text"
        color="success"
        inputProps={{ maxLength: 15 }}
        {...props}
        error={!!error}
      />
      <Box height={20}>
        <FormHelperText error>{error?.message}</FormHelperText>
      </Box>
    </>
  )
}

export default React.forwardRef(PhoneField)
